import { useEffect, useRef } from 'react';
import { AcademyRichText } from '../academy/AcademyRichText';
import { WorkingSheet } from './WorkingSheet';
interface Props {
  id: string;
  value: string;
  blocked: boolean;
  onClose: () => void;
  onChange: (text: string) => void;
}
export function WorkingTextSteps({ id, value, blocked, onClose, onChange }: Props) {
  const input = useRef<HTMLTextAreaElement>(null);
  useEffect(() => {
    if (!blocked) input.current?.focus();
  }, [blocked]);
  return (
    <WorkingSheet
      flow
      title="Text steps"
      label="Keyboard working"
      onClose={onClose}
      footer={
        <button type="button" className="btn-pill-primary w-full" onClick={onClose}>
          Done · return to writing
        </button>
      }
    >
      <label htmlFor={id} className="text-sm font-bold text-ink">
        One step per line
      </label>
      <textarea
        ref={input}
        id={id}
        aria-label="Text steps"
        readOnly={blocked}
        maxLength={20000}
        className="input-k12 mt-3 min-h-40 w-full resize-y text-base"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={String.raw`One step per line. Use \(x^2\) for a formula.`}
      />
      {value && (
        <div
          aria-label="Text steps preview"
          className="mt-4 whitespace-pre-wrap border-t border-hairline pt-4 text-sm text-ink-soft"
        >
          <AcademyRichText text={value} />
        </div>
      )}
    </WorkingSheet>
  );
}
